export const addQueryParamsToUrl = (
  url: string,
  params: { [key: string]: string }
) => {
  if (Object.values(params).length > 0) {
    const queryParams: string[] = [];
    Object.entries(params).forEach(([key, value]: [string, string]) => {
      queryParams.push(`${key}=${value}`);
    });
    url = `${url}?${queryParams.join('&')}`;
  }
  return url;
};

export const chooseRandomString = (arr: Array<string>) =>
  arr[~~(Math.random() * arr.length)];

export const pickNextIndex = (
  listLength: number,
  currentIndex: number | undefined
) => {
  if (listLength <= 0) return;

  if (currentIndex === undefined) {
    // First time: pick a random index
    currentIndex = ~~(Math.random() * listLength);
  } else {
    // Next times: go to the next index, with wrap-around
    currentIndex = (currentIndex + 1) % listLength;
  }
  return currentIndex;
};
